import styled from "styled-components";
import transparentBG from "../../assets/images/backGrounds/transparent-image.webp";
import NavbarBG from "../../assets/images/backGrounds/homePageBG.webp";
export const Styles = styled.div`
  .navbar {
    background-image: url(${transparentBG});
    background-size: 100%;
    position: fixed;
    width: 101%;
    top: 0;
    right: -1px;
    padding-block: 0 !important;
    z-index: 1004;
    transition: all 0.3s;
  }
  .navbar.sticky {
    background-image: url(${NavbarBG});
    background-size: 100%;
  }
  .navbar.init-bg {
    background-image: url(${NavbarBG}) !important;
    background-size: 100% !important;
  }
  .navbar .navbar-brand {
    margin-inline-end: 30px;
    margin-inline-start: 0;
    width: 140px;
    height: 97px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .navbar .navbar-brand img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  .navbar .navbar-nav {
    gap: 10px;
    margin-inline-end: auto;
  }
  .navbar .navbar-nav .nav-link {
    color: var(--dark-purple);
  }
  .navbar .mobile {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .navbar .dropdown .dropdown-toggle i {
    margin-inline-start: 5px;
  }
  .navbar .dropdown .dropdown-toggle::after {
    display: none;
  }
  .navbar .navbar-dropdown .dropdown-menu {
    width: 600px;
    right: 0;
    top: 130%;
    padding: 0;
    border: none;
    box-shadow: -1px -1px 5px rgba(0, 0, 0, 0.1);
    color: var(--dark-purple);
    border: 1px solid var(--dark-purple);
    overflow: hidden;
  }
  .navbar .navbar-dropdown .dropdown-menu .dropdown-divider {
    margin-block: 0;
    border: 1px solid var(--dark-purple);
  }
  .navbar .navbar-dropdown .dropdown-menu .title {
    padding: 20px 30px;
    width: fit-content;
  }
  .navbar .navbar-dropdown .dropdown-menu .row {
    justify-content: center;
    margin-inline: 0 !important;
  }
  .navbar-dropdown-spinner {
    margin: 20px;
  }
  .navbar .navbar-dropdown .dropdown-menu .dropdown-item-col {
    padding: 0;
  }
  .navbar .navbar-dropdown .dropdown-menu .dropdown-item,
  .navbar .navbar-dropdown .title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 18px;
    padding: 10px;
    height: 100%;
    color: var(--dark-purple);
  }
  .navbar .navbar-dropdown .dropdown-menu .dropdown-item:before {
    position: absolute;
    content: "";
    width: 0;
    height: 100%;
    background: var(--light-purple);
    z-index: 1;
    transition: 0.3s;
  }
  .navbar .navbar-dropdown .dropdown-menu .dropdown-item:hover {
    background-color: transparent;
  }
  .navbar .navbar-dropdown .dropdown-menu .dropdown-item:hover::before {
    width: 100%;
  }
  .navbar .navbar-dropdown .dropdown-menu .dropdown-item .course-image {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    overflow: hidden;
    z-index: 2;
  }
  .navbar .navbar-dropdown .dropdown-menu .dropdown-item .course-image img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  .navbar .navbar-dropdown .dropdown-menu .dropdown-item .course-name {
    z-index: 2;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
  }
  .navbar .navbar-dropdown .dropdown-menu .dropdown-item:hover .course-name {
    color: #fff;
  }
  .navbar .navbar-dropdown .dropdown-menu .dropdown-item .course-name.arrow {
    text-align: center;
  }
  .navbar
    .navbar-dropdown
    .dropdown-menu
    .dropdown-item
    .fa-circle-chevron-left {
    padding-block: 12.5px;
  }
  .navbar .user-data {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .navbar .user {
    width: fit-content;
  }
  .navbar .user .dropdown-menu {
    overflow: hidden;
  }
  .navbar .user .dropdown-toggle {
    color: var(--dark-purple);
    background-color: transparent;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding-inline: 0;
  }
  .navbar .user .spinner-border {
    border: 2px solid var(--dark-purple) !important;
    border-left-color: transparent !important;
  }
  .navbar .user .btn-primary .spinner-border {
    border: 2px solid #fff !important;
    border-left-color: transparent !important;
  }
  .navbar .user .btn-primary:hover .spinner-border {
    border: 2px solid var(--dark-purple) !important;
    border-left-color: transparent !important;
  }
  .navbar .user .dropdown-toggle .user-img {
    width: 37px;
    height: 37px;
    border: 3px solid var(--dark-purple);
    overflow: hidden;
    border-radius: 50%;
  }
  .navbar .user .dropdown-toggle .user-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .navbar .user .dropdown-toggle .avatar {
    padding: 5px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: var(--dark-purple);
  }
  .navbar .user .dropdown-toggle .avatar svg {
    width: 50%;
  }
  .navbar .notifications .dropdown-menu {
    top: 110% !important;
    border: 1px solid var(--dark-purple);
    padding: 10px 15px !important;
    width: 350px !important;
  }
  .navbar .user .dropdown-menu {
    top: 105%;
    padding-block: 0;
    width: 100%;
  }
  .navbar .user .dropdown-menu a {
    display: block;
    font-size: 13px;
    text-align: center !important;
    width: 100%;
    padding-block: 10px;
    border-bottom: 1px solid var(--light-purple);
  }
  .navbar .user .dropdown-menu a:hover {
    font-weight: bold;
  }
  .navbar .user .dropdown-menu .btn-primary {
    width: 100%;
    margin: 0 !important;
    border-radius: inherit;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .btn-secondary {
    margin-inline-end: 5px;
  }
  .navbar .user .spinner-border.navspinner {
    border: 2px solid var(--dark-purple) !important;
    border-left-color: transparent !important;
  }
  .navbar .not-verified {
    font-size: 13px;
    display: flex;
    gap: 5px;
    margin-inline-end: -10px;
  }
  @media (max-width: 1200px) {
    .navbar .navbar-nav {
      gap: 5px;
    }
    .navbar .nav-link {
      font-size: 12px;
    }
  }
  @media (max-width: 992px) {
    .navbar .navbar-nav {
      gap: 15px;
    }
    .navbar .notifications .dropdown-menu {
      width: 275px !important;
    }
    .navbar .nav-link {
      font-size: 14px;
    }
  }
  @media (max-width: 768px) {
    .navbar,
    .navbar.init-bg {
      background-image: url(${NavbarBG});
      background-size: cover !important;
    }
    .navbar.sticky {
      background-image: url(${NavbarBG});
      background-size: cover !important;
    }
    .navbar .navbar-dropdown .dropdown-menu {
      width: 325px;
    }
    .navbar .navbar-dropdown .dropdown-menu .dropdown-item .course-name {
      z-index: 2;
      width: 300px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .navbar .navbar-brand {
      width: 130px;
      height: 97px;
      margin-inline-end: 0px;
    }
    .navbar .navbar-brand img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
  .user-data .btn-primary {
    width: 100% !important;
  }
  .user-data .btn-primary.dropdown-toggle {
    width: fit-content !important;
  }
  .lesson-name {
    font-size: 22px;
    font-weight: bold;
    color: var(--dark-purple);
    width: 500px;
    text-align: center;
  }
  .leave {
    margin-inline-end: 30px;
  }
  .leave .btn {
    width: 140px !important;
  }
  @media (max-width: 992px) {
    .lesson-name {
      width: 100%;
      margin-top: 97px;
      background: var(--dark-purple);
      color: #fff;
      font-size: 18px;
      padding-block: 10px;
    }
  }
  @media (max-width: 768px) {
    .leave {
      margin-inline-end: 0px;
    }
    .leave .btn {
      width: 130px !important;
    }
  }
`;
